import { createReducer, on } from '@ngrx/store';
import {
  deleteLoginMethod,
  getLoginMethod,
  setLoginMethod,
  saveLoginMethod,
  updateLoginMethod
} from '../actions/loginmethod.actions';

export interface LoginMethodState {
  data: any;
}

export const initialState: LoginMethodState = {
  data: {}
};

export const loginmethodReducer = createReducer(
  initialState,
  on(getLoginMethod, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants,
    loginLoader: true
  })),
  on(setLoginMethod, (state, { loginMethodData }) => ({
    ...state,
    sidLoginMethodData: loginMethodData,
    loginLoader: false
  })),
  on(saveLoginMethod, (state, { loginMethodData }) => ({
    ...state,
    ...loginMethodData
  })),
  on(updateLoginMethod, (state, { loginMethodData }) => {
    return {
      ...state,
      ...loginMethodData
    };
  }),
  on(deleteLoginMethod, (state, { loginMethodId }) => {
    return {
      ...state,
      loginMethodId
    };
  })
);
